import {DateRangeOption} from "@/components/datePicker/subComponents/DatePickerShortcutList/DatePickerShortcutList.utils.ts";
import {StandardDateRange} from "@/lib/queries/reports.ts";
import {endOfDay, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek, subDays, subMonths} from "date-fns";

export const SLA_REPORT_STANDARD_DATE_RANGES: StandardDateRange[] = [
  StandardDateRange.TODAY,
  StandardDateRange.YESTERDAY,
  StandardDateRange.LAST_7D,
  StandardDateRange.LAST_30D,
  StandardDateRange.THIS_WEEK,
  StandardDateRange.LAST_WEEK,
  StandardDateRange.THIS_MONTH,
  StandardDateRange.LAST_MONTH,
];

export const StandardDateRangeLabels: Record<StandardDateRange, string> = {
  [StandardDateRange.LAST_24H]: "Last 24 Hours",
  [StandardDateRange.TODAY]: "Today",
  [StandardDateRange.YESTERDAY]: "Yesterday",
  [StandardDateRange.LAST_7D]: "Last 7 Days",
  [StandardDateRange.LAST_30D]: "Last 30 Days",
  [StandardDateRange.THIS_WEEK]: "This Week",
  [StandardDateRange.LAST_WEEK]: "Last Week",
  [StandardDateRange.THIS_MONTH]: "This Month",
  [StandardDateRange.LAST_MONTH]: "Last Month",
  [StandardDateRange.THIS_QUARTER]: "This Quarter",
  [StandardDateRange.LAST_QUARTER]: "Last Quarter",
  [StandardDateRange.THIS_YEAR]: "This Year",
  [StandardDateRange.LAST_YEAR]: "Last Year",
  [StandardDateRange.LAST_30_MINUTES]: "Last 30 Minutes",
  [StandardDateRange.LAST_1_HOUR]: "Last 1 Hour",
  [StandardDateRange.LAST_4_HOURS]: "Last 4 Hours",
  [StandardDateRange.LAST_12_HOURS]: "Last 12 Hours",
  [StandardDateRange.LAST_24_HOURS]: "Last 24 Hours",
  [StandardDateRange.LAST_7_DAYS]: "Last 7 Days",
  [StandardDateRange.LAST_14_DAYS]: "Last 14 Days",
  [StandardDateRange.LAST_30_DAYS]: "Last 30 Days",
  [StandardDateRange.LAST_90_DAYS]: "Last 90 Days",
};

export const SLA_REPORT_STANDARD_DATE_RANGE_OPTIONS: DateRangeOption[] = [
  {
    label: StandardDateRangeLabels[StandardDateRange.TODAY],
    value: StandardDateRange.TODAY,
    getStartDate: (date: Date) => startOfDay(date),
    getEndDate: (date: Date) => date,
  },
  {
    label: StandardDateRangeLabels[StandardDateRange.YESTERDAY],
    value: StandardDateRange.YESTERDAY,
    getStartDate: (date) => startOfDay(subDays(date, 1)), // start of day gets 00:00:00
    getEndDate: (date) => endOfDay(subDays(date, 1)),
  },
  {
    label: StandardDateRangeLabels[StandardDateRange.LAST_7D],
    value: StandardDateRange.LAST_7D,
    getStartDate: (date: Date) => subDays(startOfDay(date), 7),
    getEndDate: (date: Date) => date,
  },
  {
    label: StandardDateRangeLabels[StandardDateRange.LAST_30D],
    value: StandardDateRange.LAST_30D,
    getStartDate: (date) => subDays(startOfDay(date), 30),
    getEndDate: (date) => date,
  },
  {
    label: StandardDateRangeLabels[StandardDateRange.THIS_WEEK],
    value: StandardDateRange.THIS_WEEK,
    getStartDate: (date) => startOfDay(startOfWeek(date, {weekStartsOn: 1})),
    getEndDate: (date) => date,
  },
  {
    label: StandardDateRangeLabels[StandardDateRange.LAST_WEEK],
    value: StandardDateRange.LAST_WEEK,
    getStartDate: (date) => startOfDay(startOfWeek(subDays(date, 7), {weekStartsOn: 1})),
    getEndDate: (date) => endOfDay(endOfWeek(subDays(date, 7), {weekStartsOn: 1})),
  },
  {
    label: StandardDateRangeLabels[StandardDateRange.THIS_MONTH],
    value: StandardDateRange.THIS_MONTH,
    getStartDate: (date) => startOfDay(startOfMonth(date)),
    getEndDate: (date) => date,
  },
  {
    label: StandardDateRangeLabels[StandardDateRange.LAST_MONTH],
    value: StandardDateRange.LAST_MONTH,
    getStartDate: (date) => startOfDay(startOfMonth(subMonths(date, 1))),
    getEndDate: (date) => endOfDay(endOfMonth(subMonths(date, 1))),
  },
];
